import { OwnSpec } from "../../domain/specs/own-spec";
import { RelevantSpec } from "../../domain/specs/relevant-spec";
import {
  IActivityHistoryCommonFilterGroup,
  ActivityHistoryFilterType,
  relevantFilterId,
  ownFilterId,
} from "../model";

export const commonFilters: IActivityHistoryCommonFilterGroup[] = [
  {
    id: "common",
    title: "Comuns",
    filters: [
      {
        id: relevantFilterId,
        title: "Veure rellevants",
        spec: RelevantSpec,
        enabled: false,
        type: ActivityHistoryFilterType.Switch,
      },
      {
        id: ownFilterId,
        title: "Veure meus",
        spec: OwnSpec,
        enabled: false,
        type: ActivityHistoryFilterType.Switch,
      },
    ],
  },
];
